const VIETNAM_TIMEZONE = 'Asia/Ho_Chi_Minh';

function formatVietnamParts(date: Date) {
  const parts = new Intl.DateTimeFormat('en-US', {
    timeZone: VIETNAM_TIMEZONE,
    year: 'numeric',
    month: '2-digit',
    day: '2-digit',
    hour: '2-digit',
    minute: '2-digit',
    hour12: false,
  }).formatToParts(date);

  const get = (type: Intl.DateTimeFormatPartTypes) =>
    parts.find((part) => part.type === type)?.value ?? '';

  return {
    year: get('year'),
    month: get('month'),
    day: get('day'),
    hour: get('hour'),
    minute: get('minute'),
  };
}

export function formatFeedbackDateTime(value?: string | null): string {
  if (!value) return '-';

  const parsed = new Date(value);
  if (Number.isNaN(parsed.getTime())) return '-';

  const { year, month, day, hour, minute } = formatVietnamParts(parsed);
  return `${day}/${month}/${year} ${hour}:${minute}`;
}

export function formatProcessingDuration(
  start?: string | Date | null,
  end?: string | Date | null,
): string | null {
  if (!start || !end) return null;

  const startDate = start instanceof Date ? start : new Date(start);
  const endDate = end instanceof Date ? end : new Date(end);
  if (Number.isNaN(startDate.getTime()) || Number.isNaN(endDate.getTime())) return null;

  const diffMs = endDate.getTime() - startDate.getTime();
  if (diffMs < 0) return null;

  const totalMinutes = Math.floor(diffMs / (60 * 1000));
  if (totalMinutes < 1) return '< 1 phút';

  const days = Math.floor(totalMinutes / (60 * 24));
  const hours = Math.floor((totalMinutes % (60 * 24)) / 60);
  const minutes = totalMinutes % 60;

  const parts: string[] = [];
  if (days > 0) parts.push(`${days} ngày`);
  if (hours > 0) parts.push(`${hours} giờ`);
  if (minutes > 0) parts.push(`${minutes} phút`);

  return parts.join(' ') || '< 1 phút';
}
